import React from "react";
import './ExternalLinkComponent.scss'

interface ExternalLinkComponentProps {
    text: string
    url: string
    secondary?: boolean
    small?: boolean
    noUnderline?: boolean
}

export const ExternalLinkComponent: React.FC<ExternalLinkComponentProps> = ({text, url, secondary, small, noUnderline}) => {
    return (
        <a target='_blank'
           rel='noopener noreferrer'
           href={url}
           className={`${secondary ? 'secondary-button-color' : 'primary-color'} ${small ? 'font-sm' : 'font-md'} ${noUnderline ? 'link-no-underline' : ''}`}>
            {text}
        </a>
    )
}